import React from 'react';
import { useParams } from 'react-router-dom';

function Conversation({ solvedCaptchas }) {
  const { id } = useParams();
  const solved = solvedCaptchas[id] || {};

  return (
    <div>
      <h1>Conversation {id}</h1>
      <h2>Overview Solved Captchas</h2>
      <ul>
        {Object.keys(solved).map((participant, index) => (
          <li key={index}>
            {participant}: {solved[participant] ? 'Solved' : 'Not Solved'}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Conversation;